module.exports = __webpack_public_path__ + "img/logo-mt.0c562004.png";